'use client'

import type { ReactElement } from 'react'
import { useRouter } from 'next/navigation'
import { RefreshRouteOnSave } from '@payloadcms/live-preview-react'

/**
 * Mounted on every public page so the Payload admin live-preview iframe
 * receives push events as Paul edits a Pages row. Every event triggers
 * router.refresh(), which re-fetches the page server-side and combines
 * with the autosave interval (3s) on the Pages collection so the iframe
 * shows the latest persisted draft within a couple of seconds of typing.
 *
 * RefreshRouteOnSave (vs the lower-level useLivePreview hook) is a noop
 * outside the admin iframe and never fetches, which avoids
 * /api/pages/undefined requests when initialData has no id.
 */
export function LivePreviewListener(): ReactElement {
  const router = useRouter()
  return (
    <RefreshRouteOnSave
      refresh={() => router.refresh()}
      serverURL={process.env.NEXT_PUBLIC_SITE_URL ?? ''}
    />
  )
}
